/* eslint-disable @typescript-eslint/no-explicit-any */
import isObject from "../../../helpers/isObject";

export type Key = string | number | [any, ...unknown[]] | Record<any, any> | null | undefined | false | any[];

/** Create string key from various types of args. */
export function createKey(arg: any) {
    if (!arg) return `${arg}`;

    if (Array.isArray(arg)) {
        const sortedArray = arg.sort();
        const jsonString = JSON.stringify(sortedArray);
        return `${jsonString}`;
    }

    // if object
    if (isObject(arg)) {
        const entries = Object.entries(arg);
        const sortedEntries = entries.sort((a, b) => a[0].localeCompare(b[0]));
        const sortedObject = Object.fromEntries(sortedEntries);
        const jsonString = JSON.stringify(sortedObject);
        return `${jsonString}`;
    }

    return `${arg}`;
}
